export default "<app-mat-tree type=\"driver\" listName=\"drivers\"></app-mat-tree>\n<router-outlet></router-outlet>";